namespace('compass.arctic');
compass.requireLib('compass.util.format');

compass.arctic.HelpWidget = compass.defineWidget(function HelpWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _formatNumber = compass.util.phoneFormatter({}) || {};
	
	this.render = function(widgetElem) {
		var d = _d;
		var helpContent = d.div({className : "help"}, drawHeader);
		const isEPSReservation = _settings.account.isEPS && !_settings.meetingInfo.affiliateHandledByOurAgent && _settings.loginInfo != false;
		
		// these 4 help tab subsections are appended into the helpContent div so they can be removed/edited individually for CDS profiles on the front desk
		var helpHeader = d.div({className : "helpHeader"}, "Contact " + _settings.meetingInfo.officeName);

		if (_settings.meetingInfo.contactUsUrl) {
			var contactURL = _settings.meetingInfo.contactUsUrl;
		} else {
			var contactURL =  "mailto:" + _settings.meetingInfo.email;
		}
		var emailSection = d.div({className : "email"},
			d.div({className : "helpSubHeader"}, "Email"),
			d.div({className : "helpCopy"},
				d.span("Use this "),
				d.a({className:"helpContactURL", href: contactURL, target: "_blank"},
					d.reader('submit an email to us'),
				"form"),
				d.span(" to submit an email to us.")
			)
		);

		var phoneSection;
		if (_settings.meetingInfo.helpTabCustomerSupportMessage) {
			var helpCopyMessage = _.template(_settings.meetingInfo.helpTabCustomerSupportMessage, {
				 interpolate: /\{\{(.+?)\}\}/g
			})({
				event_tollfree_number: _formatNumber(_settings.meetingInfo.phone),
				event_international_number: _formatNumber(_settings.meetingInfo.intlPhone),
				office_display_name: _settings.meetingInfo.officeName
			});
			if (helpCopyMessage != '') {
				phoneSection = d.div({className : "phone"},
					d.div({className : "helpSubHeader"}, "Phone"),
					d.div({className : "helpCopy"}, helpCopyMessage)
				);
			}
		}

		helpContent.append(helpHeader);
		helpContent.append(emailSection);
		helpContent.append(phoneSection);
		
		var termsOfServiceSection;
		if (_settings.meetingInfo.privacyPolicyLink && _settings.meetingInfo.privacyPolicyLink.length > 0) {
			termsOfServiceSection = d.a({
					className : 'privacyPolicyLink',
					href : _settings.meetingInfo.privacyPolicyLink,
					target : '_blank',
					style : {},
					role : 'contentinfo',
					'aria-role' : 'contentinfo',
					'aria-label' : 'privacy policy',
				}, 'terms of service and privacy policy'
			);
		}
		helpContent.append(termsOfServiceSection);

		if (isEPSReservation) {
			helpHeader.text("Contact Us");
			emailSection.remove();
			phoneSection.text("Call to speak with an agent at (877) 502-7827. If you are outside the US, call our international number at +1 (417) 521-1279. Please have your Itinerary ID number ready. It can be found in your confirmation.");
			$("<br />").insertBefore(termsOfServiceSection);
		}

		widgetElem.append(
			d.div({className: 'HelpWidget', role: 'dialog', 'ARIA-role': 'dialog', 'ARIA-label': 'Help Dialog'},
				helpContent
			)
		);
	};
	
	var drawHeader = function () {
		var d = _d;
		var showDetails = d.div({ className: 'showDetails secondaryText' },
			d.span({ className: 'showDates' }, _settings.meetingInfo.datesDisplay ),
			d.span({ className: 'showVenue' }, _settings.meetingInfo.site.name ),
			d.span({ className: 'showLocation' }, _settings.meetingInfo.site.city + ", " + _settings.meetingInfo.site.state)
		);
		var headerDiv = d.div({ className: 'showHeader' },
			d.reader(d.h2('Help and Contact Details')),
			d.div({ className: 'showName notranslate' }, _settings.meetingInfo.name),
			!_settings.meetingInfo.hideMeetingSubheader ? showDetails : d.div({className: 'showDetails secondaryText'})
		);
		return headerDiv;
	};

	var _d = jQuery.dom.getContext(this);
}, {
	WUID: 'defaultHelpWidgetWUID',
	widgetName: 'HelpWidget',
	account: {}
});